import { RouteObject } from "react-router-dom";

import ProtectedRoute from "../Routes/ProtectedRoute";
import { PredefinedWord } from "../Routes/Predefined";
import { ROUTES } from "../Routes/routes";

import DeliverypartnerLayout from "../layouts/DeliverypartnerLayout";
import DeliverypartnerDashboard from "../components/Deliverypartner/DeliverypartnerDashboard";
import ChangePassword from "../layouts/ChangePassword";
import DeliveryPartnerReport from "../components/Deliverypartner/DeliveryPartnerReport";
import DeliverySchedule from "../components/Deliverypartner/DeliverySchedule";
import DeliverypartnerProfile from "../components/Deliverypartner/DeliverypartnerProfile";

export const deliveryRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute
        allowedRoles={[PredefinedWord.Roles.DELIVERYPARTNER]}
      />
    ),
    children: [
      {
        element: <DeliverypartnerLayout />,
        children: [
          {
            path: ROUTES.DELIVERYPARTNER.DELIVERYPARTNER_DELIVERYPARTNERDASHBOARD,
            element: <DeliverypartnerDashboard />,
          },
          {
            path: ROUTES.DELIVERYPARTNER.DELIVERYPARTNER_ChangePassword,
            element: <ChangePassword />,
          },
          {
            path: ROUTES.DELIVERYPARTNER.DELIVERYPARTNER_DeliveryPartnerReport,
            element: <DeliveryPartnerReport />,
          },
          {
            path: ROUTES.DELIVERYPARTNER.DELIVERYPARTNER_DeliverypartnerProfile,
            element: <DeliverypartnerProfile />,
          },
          {
            path: ROUTES.DELIVERYPARTNER.DeliverySchedule,
            element: <DeliverySchedule />,
          },
        ],
      },
    ],
  },
];